import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/api";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("chwa_admin_token", data.token);
      toast.success("Welcome back.");
      onSuccess();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen flex-col items-center justify-center px-6">
      <p className="font-display text-3xl font-bold tracking-[0.2em] text-zinc-50">CHWA</p>
      <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-zinc-500">Admin Access</p>

      <form data-testid="admin-login-form" onSubmit={submit} className="mt-10 w-full max-w-sm space-y-4 border border-zinc-800 bg-[#0D0D0D] p-8">
        <input
          data-testid="admin-input-email"
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-zinc-800 bg-[#111111] px-4 py-3.5 text-sm text-zinc-100 placeholder-zinc-600 outline-none transition-colors duration-300 focus:border-zinc-400"
        />
        <input
          data-testid="admin-input-password"
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-zinc-800 bg-[#111111] px-4 py-3.5 text-sm text-zinc-100 placeholder-zinc-600 outline-none transition-colors duration-300 focus:border-zinc-400"
        />
        {error && <p data-testid="admin-login-error" className="text-xs text-red-400">{error}</p>}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="w-full bg-zinc-100 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-zinc-950 transition-colors duration-300 hover:bg-white disabled:opacity-50"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>

      <Link to="/" data-testid="admin-back-home" className="mt-8 text-[10px] uppercase tracking-[0.3em] text-zinc-600 transition-colors duration-300 hover:text-zinc-300">
        Back to chwasupply.com
      </Link>
    </div>
  );
}
